// The attached-result contract (FOLLOWUP-URL-SURFACE.md §7, U11/U13–U19).
//
// One shared module, imported by the BL materialiser and — when P5 lands — by
// the FE component registry alike, following the ref-grammar-in-shared
// precedent (`../session/orchestration/tool-protocol/follow-up-refs.ts`).
//
// `grammar.ts` is re-exported BY NAME rather than with `export *`, because two
// of its names are also `attached-result-constants.ts`'s. Both files answer
// "the fence" and "the line ceiling", for the two different blocks this surface
// has: ``` attach-result ``` is what a MODEL writes, ``` no-edit-data-block ```
// is what we write in its place. One barrel cannot carry two answers to one
// name, so `ATTACH_FENCE_INFO_STRING` and `ATTACH_MAX_LINE_LENGTH` stay the
// AUTHORING block's here, and whoever wants the persisted block's imports
// `./grammar.js` and says so.

export {
  ATTACH_DIRECTIVE_REGEX,
  ATTACH_FIELD_INDENT,
  ATTACH_FIELD_LINE_REGEX,
  ATTACH_FIELD_SEPARATOR,
  ATTACH_ITEM_BULLET,
  ATTACH_ITEM_BULLET_REGEX,
  ATTACH_MAX_BLOCK_LENGTH,
  ATTACH_MAX_FIELDS_PER_ITEM,
  ATTACH_MAX_ITEMS,
  ATTACH_WRITER_LABEL_FIELD_KEY,
  AttachDirectiveKey,
  AttachLinkFieldKey,
  type AttachBlockDocument,
  type AttachFieldLine,
  type AttachItemBlock,
  type AttachItemProjector,
  type CapturedAtRange,
  type RowRefRecordLike,
} from "./grammar.js";
export * from "./attach-plan.js";
export * from "./attached-result-constants.js";
export * from "./contracts.js";
export * from "./detect-sentinel.js";
export * from "./enums.js";
export * from "./envelope.js";
export * from "./fence-spans.js";
export * from "./parse-attach-block.js";
export * from "./parse-attach-document.js";
export * from "./payloads/flights.contracts.js";
export * from "./payloads/hotels.contracts.js";
export * from "./payloads/links.contracts.js";
export * from "./pillar-map.js";
export * from "./pillar-names.js";
export * from "./render-sentinel.js";
export * from "./shapes/index.js";
export * from "./splice-blocks.js";
export { formatYoutubeSubscriberCount } from "./youtube-subscriber-display.js";
